import './Footer.css';

const Footer = () => (
  <footer className="site-footer">
    <div className="footer-inner">
      <span className="footer-copy">© 2026 Clayton Skaggs</span>
      <nav className="footer-links">
        <a href="https://github.com/DesertCow" className="footer-link">GitHub</a>
        <a href="https://www.linkedin.com/in/clayton-skaggs-3084b950" className="footer-link">LinkedIn</a>
        <a href="https://www.instagram.com/skagggggggs/" className="footer-link">Instagram</a>
        <a href="https://www.youtube.com/@MrClaytonskaggs" className="footer-link">YouTube</a>
      </nav>
    </div>
  </footer>
);

export default Footer;
